import React from 'react';
import type { PayoutAccountInfo } from './PayoutDialog.types';
import { AllOrNothingAmountStep } from './AllOrNothingAmountStep';
import { AmountInputStep } from './AmountInputStep';
import { NoBalanceStep } from './NoBalanceStep';

type AmountStepProps = Readonly<{
  payoutAccountInfo: PayoutAccountInfo;
  amountInMinorUnits: number;
  onAmountChange: (amountInMinorUnits: number) => void;
  onContinue: () => void;
  onClose: () => void;
  onPageViewed?: () => void;
}>;

export const AmountStep: React.FC<AmountStepProps> = ({ payoutAccountInfo, amountInMinorUnits, onAmountChange, onContinue, onClose, onPageViewed }) => {
  const availableInMinorUnits = payoutAccountInfo.balance?.available.valueInMinorUnits ?? 0;
  const minAmountInMinorUnits = payoutAccountInfo.standardPayoutFee?.freeThresholdInMinorUnits ?? 1;
  const isAllOrNothing = availableInMinorUnits > 0 && minAmountInMinorUnits >= availableInMinorUnits;

  if (availableInMinorUnits <= 0) {
    return <NoBalanceStep onClose={onClose} />;
  }

  if (isAllOrNothing) {
    return (
      <AllOrNothingAmountStep
        payoutAccountInfo={payoutAccountInfo}
        onContinue={onContinue}
        onPageViewed={onPageViewed}
      />
    );
  }

  return (
    <AmountInputStep
      payoutAccountInfo={payoutAccountInfo}
      amountInMinorUnits={amountInMinorUnits}
      onAmountChange={onAmountChange}
      onContinue={onContinue}
      onPageViewed={onPageViewed}
    />
  );
};
